export const BROWSER_SESSION = 'browser'
export const BUILDER_SESSION = 'builder'
export type SessionType = typeof BROWSER_SESSION | typeof BUILDER_SESSION

export const isSessionType = (value: unknown): value is SessionType =>
  [BROWSER_SESSION, BUILDER_SESSION].includes(value as SessionType)
